import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { ButtonComponent } from './components/button/button.component';
import { CardComponent } from './components/card/card.component';
import { IconBtnComponent } from './components/icon-btn/icon-btn.component';

@NgModule({
  imports: [CommonModule],
  declarations: [ButtonComponent, CardComponent, IconBtnComponent],
  exports: [ButtonComponent, CardComponent, IconBtnComponent],
})
export class G99UiLibraryModule {}
